import styles from '../index.scss'
import amountPriceMap from './price'

export type IDpBusinessCommodityBase = {
  detail: {
    exchangeType: number // 支付类型
    proName: string | undefined // 商品名称
    proDesc?: string | undefined // 商品描述
    stockNum?: number | undefined // 库存
    proLabelName?: string | undefined // 商品标签
    labels?: {
      id: number;
      code: string;
      name: string
    }[]
    exchangePriceSuffix?: Boolean | undefined
  }
  config?: {
    hasHiddenPrice?: Boolean | undefined
  }
}

const Base = (props: IDpBusinessCommodityBase) => {
  const proLabelList: string[] = props?.detail?.proLabelName?.split(',') || props?.detail?.labels?.map(i => i?.name) || []
  return (
    <div className={styles["dp-business-commodity--base"]}>
      {(props?.detail?.exchangeType !== 3 && !props?.config?.hasHiddenPrice) && (
        <div className={styles["dp-business-commodity--base-price"]}>
          {amountPriceMap?.(props)?.[props?.detail?.exchangeType]}
        </div>
      )}
      <div className={styles["dp-business-commodity--base-name"]}>{props?.detail?.proName}</div>
      {props?.detail?.stockNum && <div className={styles["dp-business-commodity--base-decs"]}>库存：{props?.detail?.stockNum}</div>}
      <div className={styles["dp-business-commodity--base-decs"]}>{props?.detail?.proDesc}</div>
      <div className={styles["dp-business-commodity--base-tabList"]}>
        {proLabelList.map((item: any, index: number) => (
          item ? <div className={styles["dp-business-commodity--base-tab"]} key={index}>
            {item}
          </div> : <></>
        ))}
      </div>
    </div>
  )
}

export default Base
